var _style, _g, _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPirSensorPassiveInfraredDetectorMotionDetector({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;stroke:#FFFFFF;stroke-width:0.25;stroke-miterlimit:10;}\n\t.st1{fill:none;stroke:#FFFFFF;stroke-width:0.25;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "3.9,11.6 2.5,15.6 5.3,15.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "8,11.6 6.6,15.6 9.4,15.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "12.1,11.6 10.7,15.6 13.5,15.6  "
  }))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "8,0.6 3,10.2 13,10.2 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPirSensorPassiveInfraredDetectorMotionDetector);
export default __webpack_public_path__ + "static/media/PIRSensorPassiveInfraredDetectorMotionDetector.fbfb3008063ab9bd89d1cdd464d7fbd9.svg";
export { ForwardRef as ReactComponent };